import React from 'react';

/*
 *  @Author:        Sergio Balaguer Carmona
 *  @Description:   Stateless component that renders an Arrow.
 */

const DownArrow = ( props ) => {

    return (
        <g id="Group_1592" data-name="Group 1592" transform="translate(-176.917 -856.417)">
            <line id="Line_43" data-name="Line 43" y1="119.999" transform="translate(216.415 858.167)"/>
            <path id="Path_260" data-name="Path 260" d="M99.344,51.5,61.422,89.249,23.5,51.5"
                  transform="translate(155.167 888.918)"/>
        </g>

    )

};

export default DownArrow;

